module.exports = __webpack_public_path__ + "img/hp-215.ca473b62.png";